/**
 * This class to provide url related methods
 */
export class UrlUtilsService {

    /**
     * This method to append request parameters to url and return complete url string format
     * @param url - resource url
     * @param map - request parameters
     * @example - 
     * ```
     * appendQueryString('https://api-so32.staging.nice-incontact.com',{includeEntries: false})
     * ```
     * @returns - string 
     */
    public appendQueryString(url: string, map: any): string {
        let queryString = '';
        let key = '';

        for (key in map) {
            if (map.hasOwnProperty(key)) {
                if (queryString !== '') {
                    queryString += '&';
                }
                queryString += key + '=' + encodeURIComponent(map[key]);
            }
        }

        if (url.indexOf('?') === -1) {
            url += (queryString === '') ? queryString : '?' + queryString;
        } else {
            url += (queryString === '') ? queryString : '&' + queryString;
        }
        return url;
    }
}
